import React from 'react';
import './Header.css'
import HeaderOptions from './HeaderOptions';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import CallIcon from '@material-ui/icons/Call';

function Header() {
    return (
        <div className="header">
            <div className="headerNav">
                <div className="headerNav__middle">
                    <HeaderOptions/>
                </div>
            </div>
            <div className="headerBottom">
                <div className="headerBottom__nav">
                    <div className="headerNav__left">
                        <img src="https://www.kenyanews.go.ke/wp-content/uploads/2019/02/nhw1J6oC_400x400.png" alt=""/>
                        <div className="church__description">
                            <h3>MUTHETHENI AIC </h3>
                            <p>To know Him and make Him known.</p>
                        </div>
                    </div>
                    <div className="headerBottom__middle">
                        <MailOutlineIcon className="Mui-Icon"/>
                        <div className="middle__description">
                            <h3>P.O box 30-90133</h3>
                            <p>Muthetheni-Machakos</p>
                        </div>
                    </div>
                    <div className="headerBottom__right">
                        <CallIcon className="Mui-Icon"/>
                        <div className="right__desctiption">
                            <h3>Call us now</h3>
                            <p> +254-712328150 , +254-722521248</p>
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
    )
}

export default Header
